/*
* Created by Rishabh Kumar on 18/09/20
* */
/** @jsx jsx */

import * as React from "react"
import {isEmpty as _isEmpty, map as _map, get as _get} from "lodash"
import { jsx } from "@emotion/core";
import CollapsibleCardView from "../CollapsibleCardView";
import CollapsiblePanel from "../CollapsiblePanel";
import AppLoader from "../utils/AppLoader";
import * as _ from "lodash";
import {AppConstants, ConsultationStatusConstant} from "../../utils/AppConstants";
import AppUtils from "../../utils/AppUtils";
import FlatList from "../common/FlatList";
import {TherapistPastSessionsStyles} from "../../styles/components/ongoing/therapistPastSession";
import TherapyConsultationDetailView from "../../containers/Patient/TherapyConsultationDetailsView";

interface IConsultationPanelProps {
    data: any,
    index?: number,
    fetchPastConsultationData?: (consultationId: string, doctorType: string, patientId: string) => Promise<any>,
}

interface ITherapistPastSessions {
    pastConsultations: any[],
    fetchPastConsultationData: (consultationId: string, doctorType: string, patientId: string) => Promise<any>,
}

const ConsultationPanel = (props: IConsultationPanelProps) => {
    const {data, index} = props
    const consultationDate = data && AppUtils.getDayEpochInfo(data.startTime);
    const {consultationData} = data
    const symptoms = _get(consultationData, "chiefComplaints.patientComplaints", [])
    const publicNotes = _get(consultationData, "chiefComplaints.doctorPublicNotes.publicNotes", "")
    const privateNotes = _get(consultationData, "chiefComplaints.doctorPrivateNotes.privateNotes", "")
    const [isLoading, setIsLoading] = React.useState<boolean>(false)

    const handlePanelClick = async () => {
        if(!consultationData) {
            setIsLoading(true)
            try {
                await props.fetchPastConsultationData(data.id.toString(), data.doctorType, data.patient.id.toString())
            } catch (err) {
                console.log({err})
            }
            setIsLoading(false)
        }
    }

    return (
        <CollapsiblePanel handleClick={handlePanelClick} css={TherapistPastSessionsStyles.panelContainer}>
            <div css={TherapistPastSessionsStyles.header}>
                {consultationDate.dateText} {consultationDate.month}, {consultationDate.year}
            </div>
            <div css={TherapistPastSessionsStyles.panelBody}>
                {isLoading && <AppLoader/>}
                {!isLoading &&
                    <React.Fragment>
                        {(!_isEmpty(symptoms) || !_isEmpty(publicNotes) || !_isEmpty(privateNotes)) && <div className="symptom-container summary-subcontainer">
                            {!_isEmpty(symptoms) && <div>
                                <div className="labTest-label summary-subheader brandon-bold">CHIEF COMPLAINTS</div>
                                {symptoms && symptoms.map((symptom, index: number) => {
                                    return <div key={index}>
                                        <div className="in-blk highlighted-text symptom-text">{symptom.complaint.displayValue}</div>
                                        <div className="in-blk placeholder-text">{symptom.duration && symptom.duration.count && symptom.duration.unit && `since `}</div>
                                        <div className="sub-text in-blk symptom-date" style={{ marginLeft: "20px" }}>
                                            {symptom.duration && symptom.duration.count && symptom.duration.unit &&
                                            `${symptom.duration.count} ${AppConstants.FrequencyUnit[symptom.duration.unit]}`}
                                        </div>
                                        <div className="sub-text in-blk" style={{ marginLeft: "20px", color: "grey" }}>{symptom.comment ? symptom.comment : ""}</div>
                                    </div>;
                                })}
                            </div>}
                            {!_isEmpty(publicNotes) &&
                            <div>
                                <div css={TherapistPastSessionsStyles.subHeader}>Public Notes</div>
                                <div css={TherapistPastSessionsStyles.bodyText} dangerouslySetInnerHTML={{ __html: AppUtils.formatStrongTag(publicNotes)}} />
                            </div>
                            }

                            {!_isEmpty(privateNotes) &&
                            <div>
                                <div css={TherapistPastSessionsStyles.subHeader}>Private Notes</div>
                                <div css={TherapistPastSessionsStyles.bodyText} dangerouslySetInnerHTML={{ __html: AppUtils.formatStrongTag(privateNotes) }} />
                            </div>
                            }
                        </div>}
                        <TherapyConsultationDetailView data={consultationData}/>
                    </React.Fragment>
                }
            </div>
        </CollapsiblePanel>
    )
}

const TherapistPastSessions = (props: ITherapistPastSessions) => {

    return (
        <div className={"therapist-past-sessions"}>
            <CollapsibleCardView titleComponent={"Past Session Notes"}>
                <FlatList
                    listItems={
                        _map(props.pastConsultations).filter(consultation => consultation.status === ConsultationStatusConstant.COMPLETED)
                    }
                    renderItem={
                        ({item, index}) => <ConsultationPanel data={item} index={index}/>
                    }
                    commonProps={{
                        fetchPastConsultationData: props.fetchPastConsultationData
                    }}
                />
            </CollapsibleCardView>
        </div>
    )
}

export default TherapistPastSessions